import React, { useState } from "react";
import "./numericQuestion.css";

const NumericQuestion = ({ question, required, updateProgress }) => {
  const [answer, setAnswer] = useState("");

  const handleChange = (e) => {
    const value = e.target.value.replace(/\D/g, ""); // ✅ Solo números
    setAnswer(value);
  };

  const handleBlur = () => {
    if (answer.trim() !== "") {
      updateProgress(answer.trim()); // ✅ Guarda el número final cuando el usuario sale del input
    }
  };

  return (
    <div className="numeric-question">
      <label className="question-label">
        {question} {required && <span className="required">*</span>}
      </label>
      <input
        type="text"
        className="numeric-input"
        placeholder="Ingresa un número"
        value={answer}
        onChange={handleChange}
        onBlur={handleBlur}
      />
    </div>
  );
};

export default NumericQuestion;
